document.addEventListener('DOMContentLoaded', function() {
  var nav = document.querySelector('.site-header__links')
  if (!nav || nav.querySelector('.site-header__dropdown')) return

  var links = Array.prototype.slice.call(nav.querySelectorAll('a'))
  var hasLab = links.some(function(link) {
    var label = link.textContent.trim().toLowerCase()
    return label === 'product lab' || label === 'work lab'
  })
  if (hasLab) return

  var dropdown = document.createElement('details')
  dropdown.className = 'site-header__dropdown'
  dropdown.innerHTML = [
    '<summary><span>work lab</span><span aria-hidden="true">⌄</span></summary>',
    '<div class="site-header__dropdown-menu">',
    '<a href="/pages/fabric-guide">Fabric Guide</a>',
    '<a href="/pages/craft-library">Craft Library</a>',
    '<a href="/pages/case-studies?ntk=worklab">Case Studies</a>',
    '</div>'
  ].join('')
  nav.appendChild(dropdown)
})
